import Constants, { publicConstants } from '../../constants';
import ContextProcessor from '../../context/context-processor';
import { getActiveContainerItemName, getDataContextName } from '../../container/container-utils';

/**
 * Use these utility APIs to automatically obtain the active context for the currently opened container and act on the context
 */
class ActiveContext {
  /**
   * Returns the information of the specified header from the active context
   * <br>
   *
   * @example <caption>In this example, the API returns an object containing the information in the debugInfo header</caption>
   * PCore.getContainerUtils().getActiveContext().getCoreheaders('debugInfo')
   *
   * @param headerName - Name of the header to be retrieved from the redux store eg. debugInfo
   * <br><br>
   * @returns returns - An object containing passed header information. If the specified header does not exist or
   * if it doesn't contain any information, undefined will be returned.
   * <br><br>
   */
  getCoreheaders(headerName: string): object | undefined {
    const target = `${publicConstants.APP.APP}${Constants.FORWARD_SLASH_STRING}${Constants.PRIMARY}`;
    const containerItemID = getActiveContainerItemName(target);
    const context = getDataContextName(containerItemID);
    const coreHeaders = ContextProcessor.getProperty(Constants.COREHEADERS, '', context);
    if (coreHeaders && headerName in coreHeaders) return coreHeaders[headerName];
  }
}

export default new ActiveContext();
